import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { isThisHour } from 'date-fns/esm';
import { CommonService } from 'src/app/core/common.service';
import { DataPopulationEvents, ImmigrationDataPopulationService } from 'src/app/immigration/services/data-population/ImmigrationDataPopulation.service';

@Component({
  selector: 'eos-formly-button',
  templateUrl: './formly-button.component.html',
  styleUrls: ['./formly-button.component.css']
})
export class FormlyButtonComponent extends FieldType implements OnInit, OnDestroy {
  operations: string[];

  constructor(
    private commonService: CommonService,
    private ImmigrationDataPopulation: ImmigrationDataPopulationService
  ) {
    super();
  }

  ngOnInit() {
  }

  /**Triggered subjects should be reset
   * to initial value since its inside Singleton services
   * */
  ngOnDestroy() {
    this.ImmigrationDataPopulation.GpnGuiUpdated.next(false);
  }

  onClick($event) {
    if (this.to.onClick) {
      this.operations = [];
      this.operations = this.to.onClick($event);
      this.emitOperations();
    }
  }

  /**Triggers the subject 
   * that we should listen to in component
   * */
  emitOperations() {
    if (this.operations.includes(DataPopulationEvents.GpnGuiSearch)) {
      this.ImmigrationDataPopulation.GpnGuiUpdated.next(true);
    }
  }
}
